import React from 'react';
import './Orders.css'
import {Transition} from 'react-spring/renderprops'

export class Orders extends React.Component {
    constructor(props) {
        super(props);
        this.renderDinnerOrder = this.renderDinnerOrder.bind(this);
        this.renderLunchOrder = this.renderLunchOrder.bind(this);
    }
    renderLunchOrder() {
        if(this.props.lunchOrder.name !== '') {
            return (
                <div>
                    <p>{this.props.lunchOrder.name}</p>
                    <p>Pickup Time: <span>{this.props.lunchOrderTime}</span></p>
                    <p>Order Status: <span className = "status">Confirmed</span></p>
                </div>
            );
        }
        else {
            return <p className = "empty">Looks like you haven't placed an order yet!</p>;
        }
    }
    renderDinnerOrder() {
        if(this.props.dinnerOrder.name !== '') {
            return (
                <div>
                    <p>{this.props.dinnerOrder.name}</p>
                    <p>Pickup Time: <span>{this.props.dinnerOrderTime}</span></p>
                    <p>Order Status: <span className = "status">Confirmed</span></p>
                </div>
            );
        }
        else {
            return <p className = "empty">Looks like you haven't placed an order yet!</p>;
        }
    }
    render() {
        return(
                <Transition
                items={this.props.show}
                from={{ opacity: 1 }}
                enter={{ opacity: 1 }}
                leave={{ opacity: 0}}
                config={{delay: 200, duration: 80}}>
                {show => show && (props => <div style={props}>
                    <div className = 'orders'>
                    <div className = 'orders-header'>
                            <div className = "back-button" onClick = {this.props.hideOrders}> </div>
                            <h1> Today's Orders</h1>
                    </div>
                    <Transition
                    items={this.props.show}
                    from={{ opacity: 0}}
                    enter={{ opacity: 1 }}
                    leave={{ opacity: 0 }}
                    config={{delay: 100}}>
                    {show => show && (props => 
                        <div style={props}>
                            <div className = 'order-items'>
                            <div className = 'order-item'> 
                                <h2>Lunch</h2>
                                <div className = "order-content">
                                    {this.renderLunchOrder()}
                                </div>
                            </div>
                            <div className = 'order-item'> 
                                <h2>Dinner</h2>
                                <div className = "order-content">
                                    {this.renderDinnerOrder()}
                                </div>
                            </div>
                            <div className = "order-spacer">
                            </div>
                        </div>
                    </div>)}
                    </Transition>
                    </div>
                </div>)}
                </Transition>
                
        );
        
    }

}